import { render, staticRenderFns } from "./GatewayDetails.vue?vue&type=template&id=3cd40c36&scoped=true&"
import script from "./GatewayDetails.vue?vue&type=script&lang=js&"
export * from "./GatewayDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd40c36",
  null
  
)

export default component.exports